<div class="playlist-card">
  <a [routerLink]="cardUrl()" class="card-link">
    <div class="playlist-image">
      <img
        [src]="thumbnail() | imageUrl"
        [srcset]="thumbnail() | imageUrl | youtubeSrcset"
        [sizes]="
          priority()
            ? '(max-width: 600px) 100vw, (max-width: 960px) 50vw, 33vw'
            : 'auto'
        "
        [loading]="priority() ? 'eager' : 'lazy'"
        [attr.fetchpriority]="priority() ? 'high' : null"
        alt="{{ playlist().title }}"
      />
      @if (displayModifyControls()) {
        <div class="card-actions">
          @if (canUpdate()) {
            <bn-button
              appearance="icon"
              class="action-btn large-icon"
              [routerLink]="['/playlist', playlist().shortId, 'edit']"
              matTooltip="Edit Playlist"
              (click)="$event.stopPropagation(); $event.preventDefault()"
              icon="edit"
            >
            </bn-button>
          }
          @if (canDelete()) {
            <bn-button
              appearance="icon"
              class="action-btn delete-btn large-icon"
              matTooltip="Delete Playlist"
              (click)="
                $event.stopPropagation();
                $event.preventDefault();
                deletePlaylist(playlist())
              "
              icon="delete"
            >
            </bn-button>
          }
        </div>
      }
    </div>
    <div class="playlist-info">
      <h3>{{ playlist().title }}</h3>

      @if (playlist().currentVideo) {
        <div class="current-track">
          <mat-icon>music_note</mat-icon>
          <span>{{ playlist().currentVideo }}</span>
        </div>
      }

      <p class="description">{{ playlist().description }}</p>

      <div class="playlist-meta">
        @if (authorName()) {
          <div class="author-info">
            @if (authorAvatar()) {
              <img
                [ngSrc]="authorAvatar()! | imageUrl"
                width="24"
                height="24"
                class="author-avatar"
                alt="Author avatar"
              />
            }
            <span class="author-name">{{ authorName() }}</span>
          </div>
        }
        <div class="stat" title="Live viewers">
          <mat-icon>group</mat-icon>
          <span>{{ playlist().liveUserCount || 0 }}</span>
        </div>
      </div>
    </div>
  </a>
</div>
